import { CompassOutlined, PhoneOutlined, MailOutlined } from '@ant-design/icons';
import React from 'react';
import styled from 'styled-components';
import { CompanyInformation } from '../context/ConfigurationProvider';

export type AddressProps = {
  showCompanyName?: boolean;
  className?: string;
} & CompanyInformation;

const ScAddress = styled.address`
  &&& {
    display: flex;
    flex-direction: column;

    div {
      line-height: 1.5em;
      font-size: 1em;
    }

    @media print {
      font-size: 10px;

      div {
        line-height: 14px;
      }
    }
  }
`;

const ScCompany = styled.span`
  font-size: 1.5em;
  font-weight: 800;
  text-transform: uppercase;

  @media print {
    display: none;
  }
`;

const ScCompass = styled(CompassOutlined)`
  margin-right: 5px;

  @media print {
    color: black;
  }
`;

const ScMail = styled(MailOutlined)`
  margin-right: 5px;

  @media print {
    color: black;
  }
`;

const ScPhone = styled(PhoneOutlined)`
  margin-right: 5px;

  @media print {
    color: black;
  }
`;

const ScTransparentCompass = styled(CompassOutlined)`
  visibility: hidden;
`;

const Address = ({
  showCompanyName = true,
  address1,
  address2,
  phoneNumber,
  email,
  name,
  className
}: AddressProps) => {
  return (
    <ScAddress className={className}>
      {showCompanyName && <ScCompany>{name}</ScCompany>}

      <div>
        <ScCompass />

        {address1}
      </div>

      <div>
        <ScTransparentCompass />

        {address2}
      </div>

      <div>
        <ScPhone />

        <a href={`tel:${phoneNumber}`}>{phoneNumber}</a>
      </div>

      <div>
        <ScMail />

        <a href={`mailto:${email}`}>{email}</a>
      </div>
    </ScAddress>
  );
};

export { Address };
